export const sideBarConstants = {

    SIDE_BAR_OPEN: "SIDE_BAR_OPEN",
    SIDE_BAR_CLOSE: "SIDE_BAR_CLOSE"
};
